import type { Release } from ".";
import type { Individual } from "../individuals";
import type { TaxonomicGroup } from "../taxonomicGroup";

export const ReleasesColumns: Array<{
  id: keyof Release | keyof Individual | keyof TaxonomicGroup | "executorName";
  label: string;
}> = [
  { id: "ufuName", label: "Nome UFU" },
  { id: "species", label: "Espécie" },
  { id: "executorName", label: "Designado Para" },
  { id: "expectedDate", label: "Data Planejada" },
  { id: "executionDate", label: "Data Executada" },
  { id: "status", label: "Status" },
] as const;
